import horizontalNegative from "./antecipe-logo-horizontal-negative.svg";
import horizontalPositive from "./antecipe-logo-horizontal-positive.svg";
import stackedNegative from "./antecipe-logo-stacked-negative.svg";
import stackedNegativeNoTag from "./antecipe-logo-stacked-negative-notagline.svg";
import stackedPositive from "./antecipe-logo-stacked-positive.svg";
import stackedPositiveNoTag from "./antecipe-logo-stacked-positive-notagline.svg";
import symbolNegative from "./antecipe-symbol-negative.svg";
import symbolPositive from "./antecipe-symbol-positive.svg";

export type LogoVariant = "horizontal" | "symbol" | "stacked";
export type LogoTone = "positive" | "negative";
export type LogoProps = { variant: LogoVariant; tone?: LogoTone; tagline?: boolean; height?: number; width?: number };

// SVG gerado na Q15 a partir dos PNGs; troca quando vier o vetor oficial do Marketing.
export function logoSrc(variant: LogoVariant, tone: LogoTone = "positive", tagline = true): string {
  const negative = tone === "negative";
  if (variant === "horizontal") return negative ? horizontalNegative : horizontalPositive;
  if (variant === "symbol") return negative ? symbolNegative : symbolPositive;
  if (tagline) return negative ? stackedNegative : stackedPositive;
  return negative ? stackedNegativeNoTag : stackedPositiveNoTag;
}

export default function Logo({ variant, tone = "positive", tagline = false, height, width }: LogoProps) {
  const alt = variant === "stacked" && tagline ? "Antecipe — Pagamentos & Participações S/A" : "Antecipe";
  return (
    <img
      src={logoSrc(variant, tone, tagline)}
      alt={alt}
      style={{ display: "block", height: height ? `${height}px` : undefined, width: width ? `${width}px` : undefined, maxWidth: "100%" }}
    />
  );
}
